module.exports = __webpack_public_path__ + "static/media/harvard.9d5c15c0.png";